import { PreferencesConfigService } from '../../../../services/preferences/preferences-config.service';
import { map, takeUntil, tap } from 'rxjs/operators';
import { PreferencesCurrentViewService, PreferencesStorageKeys } from 'src/app/services/preferences/preferences-current-view';
import { Component } from '@angular/core';
import { AllViewItem, PreferenceDetails, PreferencesViewData } from 'src/app/services/preferences/models/preferences.model';
import { DataContextService } from 'src/app/services/datacontext.service';
import { BaseComponent } from '../../../base-component/base-component';
import { Router } from '@angular/router';
import { RoutesConfig } from '../../../../configs/routes.config';

@Component({
  selector: 'app-view-selector',
  templateUrl: './view-selector.component.html',
  styleUrls: ['./view-selector.component.less'],
})
export class ViewSelectorComponent extends BaseComponent {
  opened = false;
  allView: AllViewItem[] = [];
  selectedView: AllViewItem;

  constructor(
    private preferencesCurrentViewService: PreferencesCurrentViewService,
    private dataContextService: DataContextService,
    private router: Router,
    private preferencesConfigService: PreferencesConfigService
  ) {
    super();
    this.dataContextService.masterDadaLoaded$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if(res) {
        this.preferencesCurrentViewService.currentView$.pipe(takeUntil(this.destroy$)).subscribe((currentView) => {
          this.selectedView = currentView.allViews.find((view) => view.id === currentView.viewId);
          this.allView = currentView.allViews.filter((item) => item.isActive).sort(a => a.id === this.selectedView.id ? -1 : 0);
          // this.getSelectedCountryBuilding(currentView.country)
          DataContextService.FilterSelectedCountryBuildings = DataContextService.Buildings;
        });
      }
    })
    
  }
  allViewPreference() {
    window.open(`/${RoutesConfig.pages.preferences}`, '_blank');
  }
  toggleDropDown(event: MouseEvent): void {
    event.stopPropagation();
    this.opened = !this.opened;
  }

  selectView(view: AllViewItem): void {
    this.dataContextService
      .getData<{ data: PreferenceDetails; status: number }>(`Views/${view.id}`)
      .pipe(
        takeUntil(this.destroy$),
        map((response) => {
          return this.preferencesConfigService.parseViewDetails(response.data);
        })
      )
      .subscribe((viewData: PreferencesViewData) => {
        this.selectedView = view;
        const View : any = {
          selectedViewId : view.id,
          revision: viewData.revision
        }
        this.dataContextService.storeInLocalStorage(PreferencesStorageKeys.SelectedViewId, View);
        this.preferencesCurrentViewService.viewChanged$.next(true);
        this.preferencesCurrentViewService.currentView$.next(viewData);
      });
  }
  getSelectedCountryBuilding(country){
    let building = []
    country.forEach(i=> {
      building.push(...DataContextService.Buildings.filter(x => x.country == i.name));
    })
    if(building){
      DataContextService.FilterSelectedCountryBuildings = building
    }
  }
}
